/// <amd-module name="Wit/WorkItemDataManager/Sources/index" />
import { WorkItemDataProviderSource } from "Wit/WorkItemDataManager/Sources/WorkItemDataProviderSource";
import { QueryDataProviderSource } from "Wit/WorkItemDataManager/Sources/QueryDataProviderSource";
import { WorkItemMetadataCacheInformationManager } from "Wit/WorkItemDataManager/CacheManagers/WorkItemMetadataCacheInformationManager";
import { IVssPageContext } from "VSS/Platform/Context";
import { IWorkItemDataSource } from "Wit/WorkItemDataManager/Contracts";
import { WorkItemAsyncDataProviderSource } from "Wit/WorkItemDataManager/Sources/WorkItemAsyncDataProviderSource";
import { WorkItemMetadataCacheStampManager } from "Wit/WorkItemDataManager/CacheManagers/WorkItemMetadataCacheStampManager";

/**
 * Retrieves the available data sources for work item data. The order of the sources does matter
 * as the sources first in the list will be used first to try and retrieve data
 * @param pageContext pageContext
 * @param cacheInformationManager The WorkItemMetadataCacheInformationManager
 * @returns The list of data sources
 */
export function getDataSources(
    pageContext: IVssPageContext,
    cacheInformationManager: WorkItemMetadataCacheInformationManager,
    cacheStampManager: WorkItemMetadataCacheStampManager
): IWorkItemDataSource[] {
    const dataSources: IWorkItemDataSource[] = [
        new WorkItemDataProviderSource(pageContext, cacheInformationManager),
        new QueryDataProviderSource(pageContext),
        new WorkItemAsyncDataProviderSource(pageContext, cacheStampManager)
    ];

    return dataSources;
}
